import {NUEModules} from 'constants/OnboardingConstants';
import {SequenceServerResponse} from 'constants/SequenceConstants';
import {Project} from 'constants/SourceConstants';
import {Entry} from 'notebook/ELNConstants';
import * as net from 'util/Net';

const OnboardingDAO = {
  fetchOnboardingTasks(): JQueryPromise<{
    modules: NUEModules;
    hasSpace: boolean;
  }> {
    return net.getJSON('/1/api/onboarding/getting-started');
  },

  completeOnboardingTask(
    module: string,
    key: string
  ): JQueryPromise<{
    markedComplete: boolean;
  }> {
    return net.postJSON({
      url: '/1/api/onboarding/getting-started',
      data: {module, key},
    });
  },

  inviteUsers({
    emails,
    recaptcha,
  }: {
    emails: Array<string>;
    recaptcha: string;
  }): JQueryPromise<{message: string}> {
    return net.postJSON({
      url: '/1/api/invites',
      data: {emails, recaptcha},
    });
  },

  externalInviteUsers({
    emails,
    inviter,
    recaptcha,
  }: {
    emails: Array<string>;
    inviter: {email: string; name: string};
    recaptcha: string;
  }): JQueryPromise<{message: string}> {
    return net.postJSON({
      url: '/1/api/external-invites',
      data: {emails, inviter, recaptcha},
    });
  },

  getOrCreateSampleEntry(): JQueryPromise<Entry> {
    return net.postJSON({
      url: '/1/api/onboarding/actions/get-or-create-sample-entry',
    });
  },

  nameCustomEntry(data: {entryName: string; projectId?: string}): JQueryPromise<Entry> {
    return net.postJSON({
      url: '/1/api/onboarding/actions/name-custom-entry',
      data,
    });
  },

  nameCustomProject(data: {projectName: string}): JQueryPromise<Project> {
    return net.postJSON({
      url: '/1/api/onboarding/actions/name-custom-project',
      data,
    });
  },

  getOrCreateNewEntry(): JQueryPromise<Entry> {
    return net.postJSON({
      url: '/1/api/onboarding/actions/get-or-create-new-entry',
    });
  },

  getOrCreateSampleSequence(): JQueryPromise<SequenceServerResponse> {
    return net.postJSON({
      url: '/1/api/onboarding/actions/get-or-create-sample-sequence',
    });
  },
};

export default OnboardingDAO;
